const euroFormatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatPrice(value) {
  const numericValue = Number(value || 0);
  return euroFormatter.format(Number.isNaN(numericValue) ? 0 : numericValue);
}
